import util from '@/utils/util.js'
const com = {
  util: util,
  localName: 'h5-jinnangmiaoji',
  projectName: '/',
  env: process.env.NODE_ENV == 'development' ? 'dev' : 'pro',
  secretKey: {
    h5: '9538b01d8d3e4c1ab3ba450adb3bea6a',
    cwapi: 'fPsm7GQjzKazwmZiIJrp99O1zNGWrc4E',
    exam: '9538b01d8d3e4c1ab3ba450adb3bea6a'
  },
  apiDomain: {
    h5: 'https://jxjyapi.dongao.cn',
    // h5: 'http://222.161.216.82:47001',
    cwapi: 'https://jxjycwapi.dongao.cn',
    // cwapi: 'http://222.161.216.82:1935'
    exam: 'https://jxjyexam.dongao.cn',
    qu: 'https://jxjyqu.dongao.cn'
  },
  getComParam() {
    return {
      deviceType: '4',
      uniqueId: 'A01054A9-888E-48A9-885B-EC60B35D1209',
      version: '2.0.4',
      appName: 'da-jxjy-app',
      app: 'app-h5'
    }
  },
  getAuthParam() {
    return {
      userId: util.getSession('userId'),
      mobileAccessToken: util.getSession('mobileAccessToken') || '',
      ...this.getComParam()
    }
  },
  getUrlEnv(url) {
    let newUrl = url.replace('https://jxjyapi.dongao.cn', '').replace('https://jxjycwapi.dongao.cn', '')
    let urlPre = newUrl.match(/\/(.+?)\//)[1]
    return {
      key: this.secretKey[urlPre],
      url: newUrl.indexOf('https://') > -1 ? newUrl : this.apiDomain[urlPre] + newUrl
    }
  },
  install: function (app) {
    app.config.globalProperties.$com = com
  }
}
export default com
